import { useEffect, useState } from "react";
import { Auth } from "aws-amplify";

export function useRole() {
  const [roles, setRoles] = useState<string[] | null>(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        // prefer custom claim if you set one; else use cognito groups
        const groups: string[] =
          user?.signInUserSession?.idToken?.payload?.["cognito:groups"] || [];
        if (mounted) setRoles(groups);
      } catch {
        if (mounted) setRoles([]);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const has = (r: string) => roles?.includes(r) ?? false;

  // Example policy: only Editors/Admins can edit Jobs; Viewers are read-only
  const isAdmin = has("Admin");
  const isSalesperson = has("Salesperson");
  const canEditJob = isAdmin || isSalesperson;
  const isReadOnly = roles !== null && !canEditJob;
  // No group at all, as a first-time Microsoft sign-in is: read-only like a
  // Rigger, but because nobody has chosen a role for them yet.
  const hasNoRole = roles !== null && roles.length === 0;

  return {
    roles,
    has,
    isAdmin,
    isSalesperson,
    canEditJob,
    isReadOnly,
    hasNoRole,
    loading: roles === null,
  };
}
